import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { Label } from '@client/app/feature-modules/shared/label/types/label.type';
import { AdaptiveColorPipe } from '@client/app/feature-modules/admin/modules/admin-labels/pipes/adaptive-color.pipe';
import { AVAILABLE_PAGE_SIZE, DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { LabelsRepo } from '@client/app/feature-modules/shared/label/services/labels.repo';
import { LabelDomainGroup } from '@client/app/feature-modules/shared/label/types/labelDomainGroups.type';

@Component({
    selector: 'mon-label-in-use-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, PaginatorModule, TranslocoModule, AdaptiveColorPipe],
    templateUrl: './label-in-use-dialog.component.html',
})
export class LabelInUseDialogComponent implements OnInit {
    private readonly config = inject(DynamicDialogConfig);
    private readonly ref = inject(DynamicDialogRef);
    protected readonly transloco = inject(TranslocoService);
    private readonly labelsRepo = inject(LabelsRepo);
    readonly AVAILABLE_PAGE_SIZE = AVAILABLE_PAGE_SIZE;
    readonly DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    label: Label = this.config.data?.label || undefined;
    domains: LabelDomainGroup[] = [];
    rows = this.DEFAULT_PAGE_SIZE;
    first = 0;


    ngOnInit (): void {
        this.getDomainGroupsFromLabel();
    }

    async getDomainGroupsFromLabel (): Promise<void> {
        this.domains = await this.labelsRepo
            .getDomainGroupsUsingLabel(this.label.id);
    }
    onPageChange (event: PaginatorState): void {
        this.first = event.first ?? 0;
        this.rows = event.rows ?? this.rows;
    }

    close (goToOverview: boolean) {
        this.ref.close({ goToOverview });
    }
}
